import { render } from "./PartnerCarousel.vue?vue&type=template&id=7a071c2a"
import script from "./PartnerCarousel.vue?vue&type=script&lang=js"
export * from "./PartnerCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__